import "@firebase/messaging";
import "firebase/firestore";
import "firebase/auth";

import * as firebase from "firebase/app";

import {
  Subject,
  Subscription
} from "rxjs";

import { AngularFireMessaging } from "@angular/fire/messaging";
import { HttpService } from '../http/http.service';
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class MessagingService {
  notificationCountSubject: Subject<any> = new Subject<any>();
  currentMessage = new Subject();
  messageSubscription: Subscription;

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private $http: HttpService
  ) { }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */
  requestPermission() {
    if (!firebase.messaging.isSupported()) {
      return Promise.resolve(null);
    }
    return new Promise((resolve) => {
      this.angularFireMessaging.requestToken.subscribe(
        data => {
          resolve(data);
        },
        _err => {
          // Permission denied or blocked; resolve null to avoid unhandled rejection
          resolve(null);
        }
      );
    });
  }

  listenNotifications() {
    if (firebase.messaging.isSupported()) {
      this.angularFireMessaging.messaging.subscribe((_messaging: any) => {

        // _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging._next = (payload: any) => {
          // console.log(payload,'messaging service');
          const notification = payload;
          notification["showPopup"] = true;
          this.currentMessage.next(notification);
          // this.getSidenavNotificationCount();
        };
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      });
      const channel = new BroadcastChannel("sw-messages");
      channel.addEventListener("message", event => {
        const notification = event.data;
        notification["showPopup"] = false;
        this.currentMessage.next(notification);
        // this.getSidenavNotificationCount();
      });
    }
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {

    if (firebase.messaging.isSupported()) {
      this.angularFireMessaging.messages.subscribe(payload => {
        // console.log("message", payload);

        this.currentMessage.next(payload);
        // this.getSidenavNotificationCount();
      });
    }
  }
}

